var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-bg_color mt-2",class:'w-full'},[_c('div',{staticStyle:{"height":"100vh","width":"100%"}},[_c('iframe',{ref:"iframeRef",attrs:{"src":_vm.iframeUrl,"width":"100%","height":"100%"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }